export default "__VITE_ASSET__2LCV8hF4__"